<div
  class="gameday-container wrapper"
  [ngClass]="{ unselectable: !(isCopyEnabled | async) }"
>
  <muni-gameday-profile-overview></muni-gameday-profile-overview>
  <router-outlet></router-outlet>
  <muni-gameday-market-drawer
    *ngIf="(marketDrawerEnabled | async)"
    [hidden]="marketDrawerHidden | async"
    [dealDate]="dealDate | async"
  >
  </muni-gameday-market-drawer>
</div>
